import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import betBothStyle from '../css/betBothCardSoccer3.css';
import {getText} from '../../../../../helpers/localization';
import {getMarketByCode} from '../helpers/marketHelpers';
import {addOpenBet} from '../../../actions/openBetsActions';
import { betSlipAnimationCalculate } from '../../../../../helpers/helperFunctions';
import { ASSETS_URL } from '../../../../../constants/endpoints';
import buttonStyle from "../../../css/button.css";

const mapStateToProps = (state, ownProps) => {
    return {openBetsSimpleList: state.vpp.openBetsSimpleList, systemLanguage: state.vpp.systemLanguage};
};

class BetBothCardSoccer3 extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            openBetsSimpleList: storeData.vpp.openBetsSimpleList,
            systemLanguage: storeData.vpp.systemLanguage,
            isClicked: false,
            animationSourceRect: {
                top: 0,
                left: 0,
            },
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                openBetsSimpleList: storeData.vpp.openBetsSimpleList,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let betBothTitle = getText("BET_BOTH", this.props.store);
        let isButtonSelected = !this._isBothSelected(this.props.markets, this.props.store);
        let disabledWrapper = isButtonSelected ? '' : betBothStyle.disabled;
        let disabledRightArrow = isButtonSelected ? '' : betBothStyle.disabledArrowRight;
        let disabledLeftArrow = isButtonSelected ? '' : betBothStyle.disabledArrowLeft;
        let disabledContainer = isButtonSelected ? '' : betBothStyle.disabledContainer;
        return (
            <div className={` ${betBothStyle.marketType} `}>
                <div className={` ${betBothStyle.marketText}`}>{betBothTitle}</div>
                <Fragment>
                    <div className={` ${betBothStyle.wrapper}  ${disabledWrapper}`} id={this.props.id}
                         onClick={() => isButtonSelected && this._placeBet(this.props.markets, this.props.store,this.props.id)}>
                        <div className={` ${betBothStyle.container}  ${disabledContainer}`}>
                            <span className={` ${betBothStyle.arrowLeft}  ${disabledLeftArrow}`}></span>
                            <span className={` ${betBothStyle.arrowRight}  ${disabledRightArrow}`}></span>
                        </div>
                        {this.state.isClicked && (<div className={`${buttonStyle.betSlipAnimation}`} style={{
                    top: `${this.state.animationSourceRect.top}px`,
                    left: `${(this.state.animationSourceRect.left)}px`
                }}>
                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`} width="35"
                         height="35"/>
                </div>)}
                    </div>

                </Fragment>
            </div>
        );
    }

    _isBothSelected(markets, store) {
        var isChecked = this._isChecked;
        let checked = true
        markets.forEach(function (market) {
            if (checked && !isChecked(store, market)) {
                checked = false;
            }

        });
        return checked;
    }

    _placeBet(markets, store,id) {
        var isChecked = this._isChecked;
        markets.forEach(function (market) {
            if (!isChecked(store, market)) {
                let bet = {
                    game: store.getState().vpp.games[store.getState().vpp.selectedGameIndex],
                    event: store.getState().vpp.events[store.getState().vpp.selectedEventIndex],
                    betType: getMarketByCode(market.code),
                    market: market
                };
                store.dispatch(addOpenBet(bet, store.getState().vpp.openBetsSimpleList));
            }
        });
        this._updateStateForAnimation(id);
    }

    _updateStateForAnimation(id) {
        let sourceRectValues = betSlipAnimationCalculate(false, document.getElementById(id));
        clearTimeout(this.handle);

        this.setState({
            ...this.state,
            isClicked: true,
            animationSourceRect: {
                top: sourceRectValues.sourceTop,
                left: sourceRectValues.sourceLeft,
            }
        })
        this.handle = setTimeout(() => {
            this.setState({
                ...this.state,
                isClicked: false
            })
        }, 1000);
    }


    _isChecked(store, market) {
        let openBetsSimpleList = store.getState().vpp.openBetsSimpleList;

        if (openBetsSimpleList.length > 0) {
            let currentSelectedGame = store.getState().vpp.games[store.getState().vpp.selectedGameIndex];
            let currentSelectedEvent = store.getState().vpp.events[store.getState().vpp.selectedEventIndex];

            for (let i = 0; i < openBetsSimpleList.length; i++) {
                if (openBetsSimpleList[i].bets[0].game.channel === currentSelectedGame.channel && openBetsSimpleList[i].bets[0].event.eventId === currentSelectedEvent.eventId && openBetsSimpleList[i].bets[0].market.id === market.id) {
                    return true;
                }
            }
        }

        return false;
    }
}

export default connect(mapStateToProps)(BetBothCardSoccer3);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/betBothCardSoccer3.js